<script>
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import moment from "moment";

import BookingService from "@/helpers/APIService/booking.service";
import AccountService from "@/helpers/APIService/account.service";
import roomService from "@/helpers/APIService/room.service";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import { required, requiredIf, decimal } from "vuelidate/lib/validators";

export default {
  components: {
    Multiselect,
    DatePicker,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "submittedAndCancelSubmit", "cancelSubmit"],
  data() {
    return {
      postBooking: {
        source: "",
        bookingRef: "",
        check_in_date: "",
        check_out_date: "",
        first_name: "",
        last_name: "",
        email: "",
        mobile_number: "",
        mobile_number_iso: "US",
        mobile_number_code: "+1 ",
        roomData: [
          {
            room_type: "",
            room_number: "",
          },
        ],
        totalNights: "",
        room_allotment: [],
        room_type: "",
        room_number: "",
        payment_status: "",
        booking_gaurantee: "",
        booking_type: "",
        comments: "",
        pre_check_in_email: false,
        payment_method: "",
        payment_account: "",
      },
      filterData: {
        bookingSource: "",
        check_in_date: "",
        check_out_date: "",
      },
      paymentMethodOptions: [],
      paymentAccountOptions: [],
      roomTypes: [],
      rooms: [],
      bookingSources: [],
      filterString: "",
      submitted: false,
      isBtnLoading: false,
    };
  },
  computed: {
    ...authComputed,
  },
  watch: {
    "postBooking.source": function (val) {
      if (val !== null) {
        this.filterData.bookingSource = val;
        this.searchRoom();
      }
    },
    "postBooking.check_in_date": function (val) {
      if (val !== null) {
        this.filterData.check_in_date = moment(val).format("YYYY-MM-DD");
        this.searchRoom();
      }
    },
    "postBooking.check_out_date": function (val) {
      if (val != null) {
        this.filterData.check_out_date = moment(val).format("YYYY-MM-DD");
        this.searchRoom();
      }
    },
  },
  mounted() {
    this.getBookingSourceByNameData();
    this.getPaymentMethod();
  },
  methods: {
    // Method is use for get all payment method
    async getPaymentMethod() {
      await AccountService.getPaymentAccount()
        .then((response) => {
          response.map((item) => {
            this.paymentMethodOptions.push({
              value: item.id,
              text: item.name,
              disabled: false,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for change payment method
    changePaymentMethod(data) {
      this.paymentAccountOptions = [];
      this.postBooking.payment_account = "";
      if (data !== null) {
        this.getPaymentAccount(data.value);
      }
    },
    // Method is use for get all payment account based on payment method
    async getPaymentAccount(id) {
      await UserService.getPaymentChildAccount(id)
        .then((response) => {
          response.map((item) => {
            this.paymentAccountOptions.push({
              value: item.id,
              text: item.name,
              disabled: false,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for get booking sources based on name
    getBookingSourceByNameData() {
      this.filterData.check_in_date = moment().format("YYYY-MM-DD");
      this.postBooking.check_in_date = moment().format("YYYY-MM-DD");
      this.filterData.check_out_date = moment()
        .add(1, "d")
        .format("YYYY-MM-DD");
      this.postBooking.check_out_date = moment()
        .add(1, "d")
        .format("YYYY-MM-DD");
      UserService.getBookingSourceByName()
        .then((response) => {
          this.bookingSources = response;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to find avl room by booking source and checkin & checkout date
    async searchRoom() {
      this.postBooking.totalNights = moment(
        this.filterData.check_out_date,
        "YYYY-MM-DD"
      ).diff(moment(this.filterData.check_in_date, "YYYY-MM-DD"), "days");
      this.filterString = "";
      if (this.filterData.bookingSource != "") {
        this.filterString +=
          "?booking_source=" + this.filterData.bookingSource.id;
      }
      if (
        this.filterData.check_in_date !== "" &&
        this.filterData.check_out_date !== ""
      ) {
        if (this.filterString == "") {
          this.filterString +=
            "?check_in_date=" + this.filterData.check_in_date;
          this.filterString +=
            "&check_out_date=" + this.filterData.check_out_date;
        } else {
          this.filterString +=
            "&check_in_date=" + this.filterData.check_in_date;
          this.filterString +=
            "&check_out_date=" + this.filterData.check_out_date;
        }
      }
      await roomService
        .getRoomDetailsForBookingCreate(this.filterString)
        .then((room_types) => {
          this.rooms = room_types;
        })
        .catch((error) => {
          errorHandler(error);
        });
      this.roomTypes = [];
      this.rooms.map((room) => {
        this.roomTypes.push({
          id: room.id,
          name: room.short_name + "-" + room.name,
        });
      });
    },
    // Method is used to allocate and validated room type section
    changeRoomType(val, index) {
      if (val !== null) {
        this.postBooking.roomData[index].room_number = "";
        this.getAvlRooms(val);
      }
    },
    // Method is used to allocate and validated room number section
    changeRoomNumber(val) {
      if (val !== null) {
        this.postBooking.room_allotment =
          this.postBooking.room_allotment.filter(
            (item) => item.room_number !== val.room_number
          );
      }
    },
    // Method is used to call api room number and maintained room number
    async getAvlRooms(data) {
      BookingService.getRoomNoAvailabilityByRoomType(
        "?check_in_date=" +
          this.filterData.check_in_date +
          "&check_out_date=" +
          this.filterData.check_out_date +
          "&room_type=" +
          data.id
      )
        .then((response) => {
          this.postBooking.room_allotment = response;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used for add new room type and number
    addRoomTypeAndNumber() {
      this.postBooking.roomData.push({
        room_type: "",
        room_number: "",
      });
    },
    // Method is used to remove that room type and number
    removeRoomTypeAndNumber(index) {
      this.postBooking.roomData.splice(index);
    },
    // Method is used to modify and maintained response data
    getResponse() {
      let total_price = parseFloat(
        parseFloat(this.postBooking.total_amount) /
          this.postBooking.roomData.length
      ).toFixed(2);
      let price_per_night = parseFloat(
        parseFloat(total_price) / parseInt(this.postBooking.totalNights)
      ).toFixed(2);
      let tempArr = [];
      this.postBooking.roomData.map((item) => {
        tempArr.push({
          room_type: item.room_type.id,
          room: item.room_number.id,
          price_per_night: price_per_night,
          total_price: total_price,
        });
      });
      let response = {
        hotel: this.hotel.id,
        booking_source: this.postBooking.source.id,
        booking_source_reference_no: this.postBooking.bookingRef,
        check_in_date: this.postBooking.check_in_date,
        check_in_time: this.hotel.check_in_time,
        check_out_date: this.postBooking.check_out_date,
        check_out_time: this.hotel.check_out_time,
        total_room: this.postBooking.roomData.length,
        stay_night: this.postBooking.totalNights,

        guest_detail: {
          email: this.postBooking.email,
          mobile:
            this.postBooking.mobile_number !== ""
              ? this.mobile_number_code + this.postBooking.mobile_number
              : "",
          first_name: this.postBooking.first_name,
          last_name: this.postBooking.last_name,
        },
        room_allotment: tempArr,
        reservation_charge: this.postBooking.total_amount,
        total_charge: this.postBooking.total_amount,
        total_payment: this.postBooking.total_payment,
        current_balance: parseFloat(
          parseFloat(this.postBooking.total_amount) -
            parseFloat(this.postBooking.total_payment)
        ),
        is_security_deposit_done: false,
        is_payment_done: Boolean(this.postBooking.payment_status.id),
        is_booking_guarantee: Boolean(this.postBooking.booking_gaurantee.id),
        guarantee_type: this.postBooking.booking_type.id,
        is_send_pre_check_in_email: this.postBooking.pre_check_in_email,
        notes: this.postBooking.comments,
      };
      if (this.postBooking.payment_status.id == 1) {
        response.payment_method = this.postBooking.payment_method.value;
        response.payment_account = this.postBooking.payment_account.value;
      }
      return response;
    },
    // Method is used to maintained save & close button events
    handleSaveAndClose() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        const uniqueValues = new Set(
          this.postBooking.roomData.map((v) => v.room_number.room_number)
        );
        if (uniqueValues.size < this.postBooking.roomData.length) {
          Middleware.notification("Room number already selected !!", "warning");
        } else {
          let data = this.getResponse();
          this.$emit("submittedAndCancelSubmit", data);
        }
      }
    },
    // Method is used to maintained save & add continue button events
    handleSaveAndAdd() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        const uniqueValues = new Set(
          this.postBooking.roomData.map((v) => v.room_number.room_number)
        );
        if (uniqueValues.size < this.postBooking.roomData.length) {
          Middleware.notification("Room number already selected !!", "warning");
        } else {
          let data = this.getResponse();
          this.$emit("submitted", data);
        }
      }
    },
    // Method is used to maintained close button events
    handleClose() {
      this.$emit("cancelSubmit");
    },
    // Method is use for disable date before today
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    // Method is use for change country in mobile number
    countryChange(code) {
      this.postBooking.mobile_number_iso = code.iso2;
      this.mobile_number_code = "+" + code.dialCode + " ";
    },
  },
  validations: {
    postBooking: {
      source: { required },
      check_in_date: { required },
      check_out_date: { required },
      bookingRef: { required },
      total_amount: { required, decimal },
      total_payment: { required, decimal },
      payment_status: { required },
      payment_method: {
        required: requiredIf(function () {
          if (
            this.postBooking.payment_status &&
            this.postBooking.payment_account !== ""
          ) {
            return true;
          }
        }),
      },
      payment_account: {
        required: requiredIf(function () {
          if (
            this.postBooking.payment_status &&
            this.postBooking.payment_method !== ""
          ) {
            return true;
          }
        }),
      },
      booking_gaurantee: { required },
      booking_type: {
        required: requiredIf(function () {
          if (this.postBooking.booking_gaurantee.id == 1) {
            return true;
          }
        }),
      },
      first_name: { required },
      last_name: { required },
      roomData: {
        required,
        $each: {
          room_type: { required },
          room_number: { required },
        },
      },
    },
  },
};
</script>

<template>
  <div>
    <div class="offcanvas-header py-0">
      <h4 class="offcanvas-title" id="offcanvasExampleLabel">
        Post New Booking
      </h4>
    </div>
    <hr />
    <div class="offcanvas-body">
      <div class="row">
        <div class="col-md-12">
          <h5 class="text-dark">Guest Details</h5>
          <hr />
          <div class="row">
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="title-input">
                <span slot="label"
                  >Source <span class="text-danger">*</span></span
                >
                <multiselect
                  v-model="postBooking.source"
                  :options="bookingSources"
                  :show-labels="false"
                  track-by="id"
                  label="name"
                  placeholder="Booking Source"
                  :class="{
                    'is-invalid': submitted && $v.postBooking.source.$error,
                  }"
                ></multiselect>
                <div
                  v-if="submitted && $v.postBooking.source.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.source.required"
                    >Booking Source is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="booking-ref">
                <span slot="label">
                  Booking Ref <span class="text-danger">*</span></span
                >
                <b-form-input
                  v-model="postBooking.bookingRef"
                  id="booking-ref"
                  type="text"
                  placeholder="Reference"
                  pattern="[A-Z0-9]{8}"
                  maxlength="8"
                  title="Enter 8 character and all must be capital and number"
                  autocomplete="off"
                  :class="{
                    'is-invalid': submitted && $v.postBooking.bookingRef.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.postBooking.bookingRef.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.bookingRef.required"
                    >Reference Number is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="last-name-input">
                <span slot="label">
                  Check-In Date <span class="text-danger">*</span>
                </span>
                <date-picker
                  lang="en"
                  placeholder="MM-DD-YYYY"
                  v-model="postBooking.check_in_date"
                  type="date"
                  value-type="format"
                  :disabled-date="notBeforeToday"
                  :class="{
                    'is-invalid':
                      submitted && $v.postBooking.check_in_date.$error,
                  }"
                ></date-picker>
                <div
                  v-if="submitted && $v.postBooking.check_in_date.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.check_in_date.required"
                    >Check-In date is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="staff-id-input">
                <span slot="label">
                  Check-Out Date <span class="text-danger">*</span>
                </span>
                <date-picker
                  lang="en"
                  placeholder="MM-DD-YYYY"
                  v-model="postBooking.check_out_date"
                  type="date"
                  value-type="format"
                  :disabled-date="notBeforeToday"
                  :class="{
                    'is-invalid':
                      submitted && $v.postBooking.check_out_date.$error,
                  }"
                ></date-picker>
                <div
                  v-if="submitted && $v.postBooking.check_out_date.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.check_out_date.required"
                    >Check-Out date is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="first_name">
                <span slot="label">
                  First Name <span class="text-danger">*</span></span
                >
                <b-form-input
                  v-model="postBooking.first_name"
                  id="first_name"
                  type="text"
                  placeholder="Give Name"
                  autocomplete="off"
                  :class="{
                    'is-invalid': submitted && $v.postBooking.first_name.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.postBooking.first_name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.first_name.required"
                    >First Name is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="last_name">
                <span slot="label">
                  Last Name <span class="text-danger">*</span></span
                >
                <b-form-input
                  v-model="postBooking.last_name"
                  id="last_name"
                  type="text"
                  placeholder="Surname"
                  autocomplete="off"
                  :class="{
                    'is-invalid': submitted && $v.postBooking.last_name.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.postBooking.last_name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.last_name.required"
                    >Last Name is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="email">
                <span slot="label">E-mail </span>
                <b-form-input
                  v-model="postBooking.email"
                  id="email"
                  type="email"
                  placeholder="name@email.com"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="mobile_number">
                <span slot="label"> Mobile Number</span>
                <vue-tel-input
                  class="text-dark-gray"
                  placeholder="+1 000 000 000"
                  v-model="postBooking.mobile_number"
                  autoFormat
                  :autoDefaultCountry="false"
                  defaultCountry="US"
                  :dropdownOptions="{
                    showDialCodeInList: true,
                    showDialCodeInSelection: true,
                    showFlags: true,
                    width: '390px',
                    showSearchBox: true,
                  }"
                  @country-changed="countryChange(...arguments)"
                ></vue-tel-input>
              </b-form-group>
            </div>
            <div class="col-md-12">
              <hr />
              <h5 class="text-dark mb-3">Room Details</h5>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="total_amount">
                <span slot="label"
                  >Total Amount <span class="text-danger">*</span></span
                >
                <b-form-input
                  v-model="postBooking.total_amount"
                  id="total_amount"
                  type="text"
                  placeholder="00.00"
                  autocomplete="off"
                  :class="{
                    'is-invalid':
                      submitted && $v.postBooking.total_amount.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.postBooking.total_amount.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.total_amount.required"
                    >Total amount is required.</span
                  >
                  <span v-if="!$v.postBooking.total_amount.decimal"
                    >Total amount accept only decimal number.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="total_payment">
                <span slot="label"
                  >Total Payment<span class="text-danger">*</span></span
                >
                <b-form-input
                  v-model="postBooking.total_payment"
                  id="total_payment"
                  type="text"
                  placeholder="00.00"
                  autocomplete="off"
                  :class="{
                    'is-invalid':
                      submitted && $v.postBooking.total_payment.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.postBooking.total_payment.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.total_payment.required"
                    >Total payment is required.</span
                  >
                  <span v-if="!$v.postBooking.total_payment.decimal"
                    >Total payment accept only decimal number.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="payment_status">
                <span slot="label">
                  Payment Status <span class="text-danger">*</span></span
                >
                <multiselect
                  v-model="postBooking.payment_status"
                  :options="[
                    { id: 1, name: 'Paid' },
                    { id: 0, name: 'Unpaid' },
                  ]"
                  :show-labels="false"
                  track-by="id"
                  label="name"
                  placeholder="Paid / Unpaid"
                  :class="{
                    'is-invalid':
                      submitted && $v.postBooking.payment_status.$error,
                  }"
                ></multiselect>
                <div
                  v-if="submitted && $v.postBooking.payment_status.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.payment_status.required"
                    >Payment type is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="booking_guarantee">
                <span slot="label">
                  Booking Guarantee <span class="text-danger">*</span>
                </span>
                <multiselect
                  v-model="postBooking.booking_gaurantee"
                  :options="[
                    { id: 1, name: 'Yes' },
                    { id: 0, name: 'No' },
                  ]"
                  :show-labels="false"
                  track-by="id"
                  label="name"
                  placeholder="Yes / No"
                  :class="{
                    'is-invalid':
                      submitted && $v.postBooking.booking_gaurantee.$error,
                  }"
                ></multiselect>
                <div
                  v-if="submitted && $v.postBooking.booking_gaurantee.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.booking_gaurantee.required"
                    >Booking gaurantee is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3" v-if="postBooking.booking_gaurantee.id == 1">
              <b-form-group class="mb-3" label-for="gaurantee_type">
                <span slot="label">
                  Guarantee Type <span class="text-danger">*</span>
                </span>
                <multiselect
                  v-model="postBooking.booking_type"
                  :options="[
                    { id: 'credit_card', name: 'Credit Card' },
                    { id: 'cash', name: 'Cash' },
                  ]"
                  :show-labels="false"
                  track-by="id"
                  label="name"
                  placeholder="Credit Card / Cash"
                  :class="{
                    'is-invalid':
                      submitted && $v.postBooking.booking_type.$error,
                  }"
                ></multiselect>
                <div
                  v-if="submitted && $v.postBooking.booking_type.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.booking_type.required"
                    >Booking type is required.</span
                  >
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row" v-if="postBooking.payment_status.id == 1">
            <div class="col-md-4">
              <b-form-group class="mb-3" label-for="payment_method">
                <span slot="label"
                  >Payment Method <span class="text-danger">*</span></span
                >
                <multiselect
                  v-model="postBooking.payment_method"
                  :options="paymentMethodOptions"
                  :show-labels="false"
                  label="text"
                  track-by="value"
                  placeholder="Payment method"
                  @close="changePaymentMethod(postBooking.payment_method)"
                  :class="{
                    'is-invalid':
                      submitted && $v.postBooking.payment_method.$error,
                  }"
                ></multiselect>
                <div
                  v-if="submitted && $v.postBooking.payment_method.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.payment_method.required"
                    >Payment method is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group class="mb-3 form-label" label-for="gender-input">
                <span slot="label"
                  >Payment Account <span class="text-danger">*</span></span
                >
                <multiselect
                  v-model="postBooking.payment_account"
                  :options="paymentAccountOptions"
                  :show-labels="false"
                  label="text"
                  track-by="value"
                  placeholder="Payment Account"
                  :class="{
                    'is-invalid':
                      submitted && $v.postBooking.payment_account.$error,
                  }"
                ></multiselect>
                <div
                  v-if="submitted && $v.postBooking.payment_account.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.postBooking.payment_account.required"
                    >Payment account is required.</span
                  >
                </div>
              </b-form-group>
            </div>
          </div>
          <div
            class="row"
            v-for="(room, index) in postBooking.roomData"
            :key="index"
          >
            <div class="col-md-4">
              <b-form-group class="mb-3" label-for="mobile-input">
                <span slot="label"
                  >Room Type <span class="text-danger">*</span></span
                >
                <multiselect
                  v-model="room.room_type"
                  :options="roomTypes"
                  :show-labels="false"
                  track-by="id"
                  label="name"
                  placeholder="Room Type"
                  @close="changeRoomType(room.room_type, index)"
                  :class="{
                    'is-invalid':
                      submitted &&
                      $v.postBooking.roomData.$each[index].room_type.$error,
                  }"
                ></multiselect>
                <div
                  v-if="
                    submitted &&
                    $v.postBooking.roomData.$each[index].room_type.$error
                  "
                  class="invalid-feedback"
                >
                  <span
                    v-if="
                      !$v.postBooking.roomData.$each[index].room_type.required
                    "
                    >Room type is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group class="mb-3 form-label" label-for="gender-input">
                <span slot="label"
                  >Room Number <span class="text-danger">*</span></span
                >
                <multiselect
                  v-model="room.room_number"
                  :options="postBooking.room_allotment"
                  :show-labels="false"
                  track-by="id"
                  label="room_number"
                  placeholder="Room Number"
                  @close="changeRoomNumber(room.room_number)"
                  :class="{
                    'is-invalid':
                      submitted &&
                      $v.postBooking.roomData.$each[index].room_number.$error,
                  }"
                ></multiselect>
                <div
                  v-if="
                    submitted &&
                    $v.postBooking.roomData.$each[index].room_number.$error
                  "
                  class="invalid-feedback"
                >
                  <span
                    v-if="
                      !$v.postBooking.roomData.$each[index].room_number.required
                    "
                    >Room number is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-4 text-dark align-items-center d-flex">
              <i
                v-if="index != 0"
                class="mdi mdi-trash-can fs-4"
                @click="removeRoomTypeAndNumber(index)"
              ></i>
              <p class="mt-3" v-if="index == 0">
                <button
                  class="btn btn-primary"
                  @click="addRoomTypeAndNumber()"
                  id="add_row"
                >
                  + Add New
                </button>
              </p>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-md-6">
              <b-form-group class="mb-3" label-for="comment">
                <span slot="label"> Comments </span>
                <b-form-input
                  class="form-control"
                  v-model="postBooking.comments"
                  id="Comments"
                  rows="3"
                  autocomplete="off"
                  placeholder="Type your comment's here"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <div class="d-flex">
                <b-form-checkbox
                  type="checkbox"
                  v-model="postBooking.pre_check_in_email"
                  name="pre_check_in_email"
                  id="pre_check_in_email"
                />
                <label class="form-check-label ms-1" for="pre_check_in_email"
                  >Send Pre-Check In Email ?</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <b-button
            variant="outline-primary"
            type="button"
            class="mx-1"
            @click="handleSaveAndClose"
            :class="{ disabled: isBtnLoading }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              v-if="isBtnLoading"
            ></i>
            Save
          </b-button>
          <b-button
            variant="outline-primary"
            type="button"
            class="mx-1"
            @click="handleSaveAndAdd"
            :class="{ disabled: isBtnLoading }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              v-if="isBtnLoading"
            ></i
            >Save & Add New</b-button
          >
          <b-button
            variant="outline-primary"
            type="reset"
            class="ms-1"
            @click="handleClose"
          >
            Cancel</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
